<template>
  <div class="modal-out">
    <div class="modal">
      <div class="modal-header">
        <div class="title">编辑</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>
      <div class="modal-body">

        <el-row class="row">
          <el-col :span="12" class="item">
            <div class="label">岗位名称</div>
            <el-input v-model="edit_Name" disabled placeholder="请输入岗位名称" ></el-input>
          </el-col>

          <el-col :span="12" class="item">
            <div class="label">选择考核名称</div>
            <el-select v-model="checkNameId" placeholder="选择考核名称" style="width: 100%">
              <el-option
                  v-for="item in list_name"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
              </el-option>
            </el-select>
          </el-col>


        </el-row>

      </div>
      <div class="modal-footer">
        <el-button @click.native="closeSelf">取消</el-button>
        <el-button :loading="loading" type="primary" @click.native="confirm">提交</el-button>
      </div>
    </div>

  </div>
</template>


<script>

import {getStaffCode} from "@/utils/auth";
import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";

export default {
  name: 'Edit',
  props: [],
  data() {
    return {

      loading: false,

      jobClassId:'',
      edit_Name:'',

      list_name:[],
      checkNameId:'',

    }
  },
  methods: {
    init(row){

      this.jobClassId=row.id;
      this.edit_Name = row.name;

      this.checkNameId = '';

      this.getNameList();

    },

    closeSelf() {
      this.loading= false
      this.$emit("closeMe");
    },


    getNameList(){
      let that = this;

      that.loading = true;

      this.$axios({
        method: 'post',
        url: this.$shopUrl+'CheckName/AdmList',
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          pageIndex: this.currentPage,
          pageSize: this.pageSize,
        }
      }).then( (response)=> {
        //console.log(response);
        that.loading = false;

        if(response.data.error == 0){
          this.list_name = response.data.data.list;
        }else if(response.data.error == 1){
          this.$message(response.data.message);
        }else{
          console.log(response.data.message);
        }

      }).catch(function (error) {
        that.loading = false;
        console.log(error);
      });
    },


    confirm(){

      if(this.checkNameId === ''){
        this.$message("选择考核名称");
        return;
      }


      if(this.loading){
        return;
      }else{
        this.loading = true;
      }

      this.$axios({
        method: 'post',
        url: this.$shopUrl+'CheckNameJobClassRel/AdmAdd',
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          checkNameId: this.checkNameId,
          jobClassId:this.jobClassId,
        }
      }).then( (response)=> {
        //console.log(response)
        this.loading = false;
        if(response.data.error == 0){
          this.$emit("closeMe");
          this.$emit("getList");
        }else{
          this.$message(response.data.message);
        }

      }).catch(function (error) {
        console.log(error);
      });

    },


  }
}
</script>

